<template>
  <div>
    <video autoplay muted loop playsinline>
      <source src="https://branton.io/media/home-mobile-bg.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: "VimeoMobile",
};
</script>
